import { apiFetch } from './client'

export interface AgentSetup {
  download_url: string
  instruction: string
  expires_at: string
  expires_in: number
  version: string
}

// The browser knows the public origin even behind TLS termination or Vite's proxy.
export function usePublicOrigin(setup: AgentSetup, origin: string): AgentSetup {
  const serverUrl = new URL(setup.download_url, origin)
  const downloadUrl = new URL(serverUrl.pathname + serverUrl.search, origin).href
  return {
    ...setup,
    download_url: downloadUrl,
    instruction: setup.instruction.split(serverUrl.origin).join(origin),
  }
}

export async function createAgentSetup(): Promise<AgentSetup> {
  const setup = await apiFetch<AgentSetup>('POST', '/api/agent-setup/')
  return usePublicOrigin(setup, window.location.origin)
}
